import React from 'react'
import PropTypes from 'prop-types'
import Datetime from 'react-datetime'
import { getYear } from '../Utils/cvDataHelpers'
import Trash from 'react-feather/dist/icons/trash.js'
import 'react-datetime/css/react-datetime.css'

const CertificationsSection = ({
  isOpen,
  toggleSection,
  combinedCertifications,
  openCertifications,
  toggleCertification,
  selectedCertifications,
  handleSelectionChange,
  handleCertificationInputChange,
  handleDelete,
  isRegistrationFlow,
}) => {
  const renderYearPicker = (value, onChange, disabled) => {
    return (
      <Datetime
        value={value ? getYear(value).toString() : ''}
        onChange={(date) => {
          const year = typeof date === 'string' ? date : date.format('YYYY')
          onChange(`${year}-01-01 01:00:00`)
        }}
        viewMode="years"
        dateFormat="YYYY"
        timeFormat={false}
        closeOnSelect={true}
        initialViewMode="years"
        inputProps={{
          className: 'form-control',
          disabled: disabled,
        }}
      />
    )
  }

  return (
    <div className="mb-5">
      <div className="mb-3 d-flex align-items-center" onClick={() => toggleSection('certifications')} style={{ cursor: 'pointer' }}>
        <span className="form-title-chip rounded-circle mr-2">5</span>

        <h4 className="mb-0">Vos certifications</h4>

        <span className="ml-auto h3 text-secondary mb-0">{isOpen ? '-' : '+'}</span>
      </div>

      { isOpen && (
        <>
          {combinedCertifications.length === 0 ? (
            <div className="callout callout-secondary text-center col-md-7 mx-auto">
              Aucune certification à comparer.
            </div>
          ) : (
            combinedCertifications.map((certification, index) => (
              <div key={certification._id} className="callout py-3">
                <div className="d-flex align-items-center" style={{ cursor: 'pointer' }}>
                  <div className="d-flex align-items-start mr-4 flex-grow-1" onClick={() => toggleCertification(certification._id)}>
                    <>
                      {certification.isIdentical && <span className="badge badge-success mt-1 mr-3">Identique</span>}
                      {certification.isDifferent && <span className="badge badge-info mt-1 mr-3">Différent</span>}
                      {certification.isNew && <span className="badge badge-primary text-white mt-1 mr-3">Nouveau</span>}
                      {certification.isCurrent && <span className="badge badge-secondary mt-1 mr-3">Twineeds</span>}
                    </>

                    <h5 className="mb-0">{certification.label}</h5>
                  </div>

                  <div className="ml-auto d-flex align-items-center">
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm btn-round mr-3"
                      onClick={(e) => {
                        e.stopPropagation()
                        handleDelete('certifications', index)
                      }}
                    >
                      <Trash/>
                    </button>

                    <span className="h4 text-secondary mb-0" onClick={() => toggleCertification(certification._id)}>{openCertifications[certification._id] ? '-' : '+'}</span>
                  </div>
                </div>

                { openCertifications[certification._id] && (
                  <div className="row mt-3">
                    {/* Analyse Data Column */}
                    {certification.analyseData && (
                      <div className={`col-md-${certification.isDifferent ? '6' : '12'}`}>
                        <div className={`p-3 mb-3 border rounded ${certification.isDifferent && selectedCertifications[certification._id] !== 'analyseData' ? 'border-light' : ''}`}>
                          {certification.isDifferent && (
                            <div className="custom-control custom-switch mb-2">
                              <input
                                className="custom-control-input"
                                type="checkbox"
                                id={`certification-${certification._id}-analyse`}
                                checked={selectedCertifications[certification._id] === 'analyseData'}
                                onChange={() => handleSelectionChange('certifications', certification._id, 'analyseData')}
                              />

                              <label className="custom-control-label" htmlFor={`certification-${certification._id}-analyse`}>
                                Nouvelle donnée du CV
                              </label>
                            </div>
                          )}

                          {certification.analyseData && (
                            <div style={{ opacity: certification.isDifferent && selectedCertifications[certification._id] !== 'analyseData' ? 0.5 : 1 }}>
                              <div className="row">
                                <div className="col-md-8">
                                  <div className="form-group mb-2">
                                    <label htmlFor={`certification-${certification._id}-analyse-label`}>Certification</label>

                                    <input
                                      type="text"
                                      className="form-control"
                                      id={`certification-${certification._id}-analyse-label`}
                                      value={certification.analyseData.label}
                                      onChange={(e) => handleCertificationInputChange(index, 'analyseData', 'label', e.target.value)}
                                      disabled={selectedCertifications[certification._id] !== 'analyseData'}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="form-group mb-0">
                                    <label>Année d'obtention</label>
                                    {renderYearPicker(
                                      certification.analyseData.date,
                                      (val) => handleCertificationInputChange(index, 'analyseData', 'date', val),
                                      selectedCertifications[certification._id] !== 'analyseData'
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {/* Freelance Data Column */}
                    {!certification.isIdentical && (certification.freelanceData || certification.isDifferent) && (
                      <div className={`col-md-${certification.isDifferent ? '6' : '12'}`}>
                        <div className={`p-3 mb-3 border rounded ${certification.isDifferent && selectedCertifications[certification._id] !== 'freelanceData' ? 'border-light' : ''}`}>
                          {certification.isDifferent && (
                            <div className="custom-control custom-switch mb-2">
                              <input
                                className="custom-control-input"
                                type="checkbox"
                                id={`certification-${certification._id}-freelance`}
                                checked={selectedCertifications[certification._id] === 'freelanceData'}
                                onChange={() => handleSelectionChange('certifications', certification._id, 'freelanceData')}
                              />

                              <label className="custom-control-label" htmlFor={`certification-${certification._id}-freelance`}>
                                Donnée actuelle
                              </label>
                            </div>
                          )}

                          {certification.freelanceData && (
                            <div style={{ opacity: certification.isDifferent && selectedCertifications[certification._id] !== 'freelanceData' ? 0.5 : 1 }}>
                              <div className="row">
                                <div className="col-md-8">
                                  <div className="form-group mb-2">
                                    <label htmlFor={`certification-${certification._id}-freelance-label`}>Certification</label>

                                    <input
                                      type="text"
                                      className="form-control"
                                      id={`certification-${certification._id}-freelance-label`}
                                      value={certification.freelanceData.label}
                                      onChange={(e) => handleCertificationInputChange(index, 'freelanceData', 'label', e.target.value)}
                                      disabled={selectedCertifications[certification._id] !== 'freelanceData'}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="form-group mb-0">
                                    <label>Année d'obtention</label>
                                    {renderYearPicker(
                                      certification.freelanceData.date,
                                      (val) => handleCertificationInputChange(index, 'freelanceData', 'date', val),
                                      selectedCertifications[certification._id] !== 'freelanceData'
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))
          )}
        </>
      )}
    </div>
  )
}

CertificationsSection.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleSection: PropTypes.func.isRequired,
  combinedCertifications: PropTypes.array.isRequired,
  openCertifications: PropTypes.object.isRequired,
  toggleCertification: PropTypes.func.isRequired,
  selectedCertifications: PropTypes.object.isRequired,
  handleSelectionChange: PropTypes.func.isRequired,
  handleCertificationInputChange: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  isRegistrationFlow: PropTypes.bool.isRequired,
}

CertificationsSection.defaultProps = {
  isRegistrationFlow: false,
}

export default CertificationsSection
